
export const paddingX = v => {
  return {
    paddingLeft: v,
    paddingRight: v
  }
}


export const paddingY = v => {
  return {
    paddingTop: v,
    paddingBottom: v
  }
}